/* eslint-disable @typescript-eslint/no-explicit-any */

import React, {useMemo} from 'react';
import {StyleProp, View, ViewStyle} from 'react-native';
import Select from '.';
import {countryData} from '../../../../data/constants/country';
import styles from '../styles';

interface CountrySelectProps {
  label?: string;
  required?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  name?: string;
  error?: string;
  showError?: boolean;
  isEditable?: boolean;
  style?: StyleProp<ViewStyle>;
  exceptCode?: string[];
}

export interface CountryValue {
  value: string;
  label: string;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
  label = '',
  required = false,
  value = '',
  onChange,
  name = '',
  error = '',
  showError = false,
  isEditable = true,
  style = {},
  exceptCode = [],
}) => {
  // Transform countryData to match the expected format for react-select
  const options: CountryValue[] = useMemo(() => {
    const countries = countryData.reduce((acc: CountryValue[], country) => {
      if (
        !(
          exceptCode.includes(country.code) || exceptCode.includes(country.name)
        )
      ) {
        acc.push({
          value: country.name,
          label: country.name,
        });
      }
      return acc;
    }, []);
    return [
      {
        label: 'Choisir',
        value: '',
      },
      ...countries,
    ];
  }, []);

  const handleSelectChange = (
    _name: string,
    value: string,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    fired: boolean,
  ) => {
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <View style={[styles.container, style]}>
      <Select
        label={label ?? ''}
        name={name}
        required={required}
        data={options}
        value={value ?? ''}
        onChange={handleSelectChange}
        disabled={!isEditable}
        error={error}
        showError={showError}
      />
    </View>
  );
};
